export default ['Welcome', 'Check Out', 'Confirmation']
